import { IS_LOADING, ERROR} from "../../constants";

export { IS_LOADING, ERROR }

export const ADD_ACTIVITY_TYPE = 'ADD_ACTIVITY_TYPE';
export const UPDATE_ACTIVITY_TYPE = 'UPDATE_ACTIVITY_TYPE';
export const DELETE_ACTIVITY_TYPE = 'DELETE_ACTIVITY_TYPE';
export const DELETE_ALL_ACTIVITY_TYPE = 'DELETE_ALL_ACTIVITY_TYPE';
export const LOAD_ACTIVITY_TYPES = 'LOAD_ACTIVITY_TYPES';
export const SYNCHRO_GET_API_ACTIVITY_TYPES = 'SYNCHRO_GET_API_ACTIVITY_TYPES';

export const DRIVING_ACTIVITY_TYPE_CODE = "ROULAGE";
export const WORK_ORDER_ACTIVITY_TYPE_CODE = "NUMOT";